module.exports = __webpack_public_path__ + "img/overview_info2.d3293491.jpg";